// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"789ee14b","551":"49c65057"}[chunkId] + ".chunk.css";
};